import React from 'react';

export default function Impresszum() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Impresszum</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Szolgáltató adatai</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="mb-2"><strong>Cég neve:</strong> XL Bútor és Szőnyeg</p>
              <p className="mb-2"><strong>Székhely:</strong> 4600 Kisvárda, Attila u. 61.</p>
              <p className="mb-2"><strong>E-mail:</strong> xlbutorbolt@gmail.com</p>
              <p className="mb-2"><strong>Telefon:</strong> 06 (70) 417 9210</p>
              <p className="mb-2"><strong>Nyitvatartás:</strong> Hétfő-Péntek: 9:00-17:00, Szombat: 8:00-13:00</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Tevékenységi kör</h2>
            <p>Bútorok és szőnyegek kiskereskedelme, lakberendezési tanácsadás, egyedi bútorkészítés.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Weboldal működtetése</h2>
            <p>
              Ez a weboldal információs célokat szolgál, ahol bemutatjuk termékeinket és szolgáltatásainkat. 
              A weboldal tartalma tájékoztató jellegű, nem minősül ajánlattételnek.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Szerzői jogok</h2>
            <p>
              A weboldalon található szövegek, képek, logók és egyéb tartalmak szerzői jogi védelem alatt állnak. 
              Tartalmak másolása, terjesztése csak előzetes írásos engedéllyel lehetséges.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Felelősség kizárása</h2>
            <p>
              A weboldal tartalmának pontosságáért minden erőfeszítést megteszünk, azonban nem vállalunk felelősséget 
              a tartalomban esetlegesen előforduló hibákért vagy hiányosságokért.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Harmadik felek linkjei</h2>
            <p>
              Weboldalunkon található külső linkek csak tájékoztató jellegűek. A külső weboldalak tartalmáért 
              nem vállalunk felelősséget.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Utolsó módosítás:</strong> 2024. december
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
